import { render, staticRenderFns } from "./MultilingualTextarea.vue?vue&type=template&id=66a86606"
import script from "./MultilingualTextarea.vue?vue&type=script&lang=js"
export * from "./MultilingualTextarea.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports